import PropTypes from 'prop-types';
import Button from '../../common/Button';

import styles from './upload-file-components.module.scss';

export function UploadFileFooter({ handleUpload, onClose, disabled, isSubmitInProgress }) {
  return (
    <div className={styles.footer}>
      <Button text="Close" onClick={onClose} color="white" shouldUseModernStyles />
      <Button
        text="Upload"
        onClick={handleUpload}
        loading={isSubmitInProgress}
        disabled={disabled}
        shouldUseModernStyles
      />
    </div>
  );
}

UploadFileFooter.propTypes = {
  handleUpload: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  isSubmitInProgress: PropTypes.bool.isRequired,
};
